module.exports = __webpack_public_path__ + "img/提升机.4f5b944b.png";